import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";

var scope_0 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/032bc0084361dc12ef89a3d01ed34041.js')["default"];

var scope_1 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0a8f86d8dc8314fb01ff9de5810f5c1b.js')["default"];

var scope_2 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1455e38c6c158a4f8e8f4f891f2ed57e.js')["default"];

var scope_3 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/169723258108d1786ad9f63e2a533b99.js')["default"];

var scope_4 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/27b2dfbffede9e76522b1c2d4c313e21.js')["default"];

var scope_5 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2c53eefaa7217fcbfe40cc0ee0492924.js')["default"];

var scope_6 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4739c0dd17a28e58353ea0e00357ad30.js')["default"];

var scope_7 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4c045b9c6e8f556bc3976794e52b7264.js')["default"];

var scope_8 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/50a7c4e56f6df26689a4081f02b1ea11.js')["default"];

var scope_9 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/56cc3ef9e691c1fed3e7173997e8486e.js')["default"];

var scope_10 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/59085ec44afe9563ebd7e01719d593ce.js')["default"];

var scope_11 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/59bef465f8b6a455184e9ea31ec5eb01.js')["default"];

var scope_12 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5e2f463fc70e80427c01e9e855602400.js')["default"];

var scope_13 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/60dd9b99a1d09f5726fb36db721ef81e.js')["default"];

var scope_14 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/625a8abb824cd7fd2bb3733dfd5be239.js')["default"];

var scope_15 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7c369811c14edb305d19670799dca6ed.js')["default"];

var scope_16 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8abe1b891008d3deb79d214e0552a0ac.js')["default"];

var scope_17 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/97fbe56cd96f4318e399fcdd8d819855.js')["default"];

var scope_18 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9a5100e7ee02167a09266180e972717b.js')["default"];

var scope_19 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a7fd337624225313d6a793fdf4f690db.js')["default"];

var scope_20 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bdbb8a6715a54d1df6a51c61a5af9a0c.js')["default"];

var scope_21 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cfab5c5e81af0d0aa128931de26209cf.js')["default"];

var scope_22 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d06925bd207c58dc5a46c7ffa5d560c6.js')["default"];

var scope_23 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d820eeda59d55ac4d9663542d7bef5e8.js')["default"];

var scope_24 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/df75fba489e9450bf9f12b2d3d39e796.js')["default"];

var scope_25 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js')["default"];

var scope_26 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f02cd2612d8d5a5abf6097aeefd3322c.js')["default"];

var scope_27 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f98440b4f13f4b4b69ae493fee701481.js')["default"];

var __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8, scope_9, scope_10, scope_11, scope_12, scope_13, scope_14, scope_15, scope_16, scope_17, scope_18, scope_19, scope_20, scope_21, scope_22, scope_23, scope_24, scope_25, scope_26, scope_27);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}